import React, {useState} from 'react'
import PlayerUtil from "../../../util/PlayerUtil";

const FARBE_DUNKEL = "#E6946C";
const FARBE_HELL = "#E0AF97";

export default function SchweizerSystemRundeTabelle({tournament, tabellen, isSetModus, selectedPlayerId, gruppe, runde, onPlayerSelect}) {

    const [showSpiele, setShowSpiele] = useState(false);

    const showBuchholz = tournament.buchholzWertung === true;
    // Bei Buchholz-Wertung sind die Spiele-Spalten optional und standardmäßig ausgeblendet
    const spieleSichtbar = !showBuchholz || showSpiele;

    // Sichtbare Spalten ab Punkte, die Farbe wechselt je Spalte zwischen dunkel und hell
    const sichtbareSpalten = ["punkte"];
    if( showBuchholz ) {
        sichtbareSpalten.push("bh", "bhf");
    }
    if( spieleSichtbar ) {
        sichtbareSpalten.push("spiele");
    }
    sichtbareSpalten.push("legs");
    const farbe = (spalte) => sichtbareSpalten.indexOf(spalte) % 2 === 0 ? FARBE_DUNKEL : FARBE_HELL;

    const getTableArea = () => {
        if( !tabellen ) {
            return "";
        }
        let rows = [];
        let position = 1;
        rows.push(<div key={"table_header_1_group_" + gruppe + "_runde_" + runde} className="grid" style={{paddingLeft:10,paddingRight:10, paddingTop:10}}>
            <div className="col"></div>
            <div className="col-fixed" style={{width:50, textAlign:"center", backgroundColor:farbe("punkte"), fontSize:12}}>Punkte</div>
            {showBuchholz && <>
                <div className="col-fixed" style={{width:40, textAlign:"center", backgroundColor:farbe("bh"), fontSize:12}}>BH</div>
                <div className="col-fixed" style={{width:45, textAlign:"center", backgroundColor:farbe("bhf"), fontSize:12}}>BHF</div>
            </>}
            {spieleSichtbar &&
                <div className="col-fixed" style={{width:75, textAlign:"center", backgroundColor:farbe("spiele"), fontSize:12}}>Spiele</div>
            }
            <div className="col-fixed" style={{width:50, textAlign:"center", backgroundColor:farbe("legs"), fontSize:12}}>{isSetModus ? "Sets" : "Legs"}</div>
        </div>);
        rows.push(<div key={"table_header_2_group_" + gruppe + "_runde_" + runde} className="grid" style={{paddingLeft:10,paddingRight:10}}>
            <div className="col-fixed" style={{width:20}}></div>
            <div className="col"></div>
            <div className="col-fixed" style={{width:50, backgroundColor:farbe("punkte")}}></div>
            {showBuchholz && <>
                <div className="col-fixed" style={{width:40, backgroundColor:farbe("bh")}}></div>
                <div className="col-fixed" style={{width:45, backgroundColor:farbe("bhf")}}></div>
            </>}
            {spieleSichtbar && <>
                <div className="col-fixed" style={{width:25, backgroundColor:farbe("spiele"), textAlign:"center"}}>S</div>
                <div className="col-fixed" style={{width:25, backgroundColor:farbe("spiele"), textAlign:"center"}}>U</div>
                <div className="col-fixed" style={{width:25, backgroundColor:farbe("spiele"), textAlign:"center"}}>V</div>
            </>}
            <div className="col-fixed" style={{width:25, backgroundColor:farbe("legs"), textAlign:"center"}}>G</div>
            <div className="col-fixed" style={{width:25, backgroundColor:farbe("legs"), textAlign:"center"}}>V</div>
        </div>);
        let anzahlDieWeiterKommen = tournament.anzahlSpielerGold;
        let rangliste = tabellen.rangliste;
        for(let i = 0; i < rangliste.length ;i++) {
            let ranglisteEinzel = rangliste[i];
            let styleRow = i < anzahlDieWeiterKommen ? {backgroundColor: "#82e3d9"} : {};
            if( selectedPlayerId !== undefined && selectedPlayerId === ranglisteEinzel.playerid ) {
                styleRow = {...styleRow, backgroundColor: "#FD8943"};
            }
            rows.push(<div  key={"table_header_group_" + gruppe + "_runde_" + runde + "_playerid_" + ranglisteEinzel.playerid}
                            className="grid" style={{paddingLeft:10,paddingRight:10, paddingTop:5}}
                            onMouseOver={() => onPlayerSelect(ranglisteEinzel.playerid)} onMouseOut={() => onPlayerSelect(undefined)}>
                <div className="col-fixed" style={{...styleRow,width:20}}>{position}.</div>
                <div className="col" style={{...styleRow, verticalAlign: "middle", display:"flex"}}>
                    {PlayerUtil.getSpielerName(tournament.tournamentPlayerEntities, ranglisteEinzel.playerid)}
                </div>
                <div className="col-fixed" style={{width:50, backgroundColor:farbe("punkte"), textAlign:"center"}}>{ranglisteEinzel.punkte}</div>
                {showBuchholz && <>
                    <div className="col-fixed" style={{width:40, backgroundColor:farbe("bh"), textAlign:"center"}}>{ranglisteEinzel.buchholz}</div>
                    <div className="col-fixed" style={{width:45, backgroundColor:farbe("bhf"), textAlign:"center"}}>{ranglisteEinzel.feinBuchholz}</div>
                </>}
                {spieleSichtbar && <>
                    <div className="col-fixed" style={{width:25, backgroundColor:farbe("spiele"), textAlign:"center"}}>{ranglisteEinzel.gewonnenespiele}</div>
                    <div className="col-fixed" style={{width:25, backgroundColor:farbe("spiele"), textAlign:"center"}}>{ranglisteEinzel.unentschiedenspiele}</div>
                    <div className="col-fixed" style={{width:25, backgroundColor:farbe("spiele"), textAlign:"center"}}>{ranglisteEinzel.verlorenespiele}</div>
                </>}
                <div className="col-fixed" style={{width:25, backgroundColor:farbe("legs"), textAlign:"center"}}>{ranglisteEinzel.anzahlLegsGewonnen}</div>
                <div className="col-fixed" style={{width:25, backgroundColor:farbe("legs"), textAlign:"center"}}>{ranglisteEinzel.anzahlLegsVerloren}</div>
            </div>);
            position++;
        }
        return rows;
    }

    return <div style={{minWidth: 400, backgroundColor: "white", color: "black", textAlign: "left", marginTop: 10}}>
        <div style={{backgroundColor: "#26a69a", color: "#f2f2f2", fontSize: 16, fontWeight: "bold", textAlign: "center", padding:10, position: "relative"}}>
            <div>Gruppe {gruppe} / Runde {runde} - Tabelle</div>
            {showBuchholz &&
                <i className={showSpiele ? "pi pi-eye-slash" : "pi pi-eye"}
                   title={showSpiele ? "Spiele ausblenden" : "Spiele einblenden"}
                   style={{position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", cursor: "pointer"}}
                   onClick={() => setShowSpiele(!showSpiele)}/>
            }
        </div>
        <div style={{minWidth: 400, marginTop:10}}>
            <div style={{backgroundColor: "#d6f5f3"}}>
                {getTableArea()}
            </div>
        </div>
    </div>
}

